// Typed client for GET /api/v1/layers (ROADMAP.md v0.6.3). Replaces map/layers.ts's hardcoded
// DATED_RASTERS/STATIC_LAYERS constants and map/layerHealth.ts's client-side WMS probing —
// layer existence and availability are now decided server-side (app/geoserver.py, a GetMap
// pixel-probe, not GetCapabilities — see that module's docstring for why). Tiles themselves are
// still fetched directly from GeoServer by OpenLayers; this only ever asks for small JSON.

import { apiFetch } from './platformApi';

export type LayerHealth = 'available' | 'missing' | 'unreachable';

export interface ApiLayer {
  id: string;
  title: string;
  kind: 'raster' | 'vector';
  date: string | null;
  source_name: string | null;
  is_test: boolean;
  health: LayerHealth;
}

export async function fetchLayers(workspace: string): Promise<ApiLayer[]> {
  const res = await apiFetch(`/api/v1/layers?workspace=${encodeURIComponent(workspace)}`);
  if (!res.ok) throw new Error(`GET /api/v1/layers -> ${res.status}`);
  const body: unknown = await res.json();
  if (!Array.isArray(body)) throw new Error('GET /api/v1/layers: expected a JSON array');
  return body as ApiLayer[];
}
